import { alpha } from '@mantine/core';

import { rgbaToHexa } from '../../../../utils/rgbaToHexa';

export function changeColorOpacity(color: string, newOpacity: number) {
  const newRgbaColor = alpha(color, newOpacity / 100);
  return rgbaToHexa(newRgbaColor);
}
